import React, { useEffect } from 'react';

const InReviewBottomAction = ({
	selectedIds,
	setSelectedIds,
	markAllToComplete,
	isAllSelected,
	selectAll,
	setSelectAll,
	onCompleteReview,
	totalElements,
	loadedItems
}) => {
	useEffect(() => {
		if (isAllSelected) {
			setSelectAll(true);
		} else {
			setSelectAll(false);
		}
	}, [isAllSelected]);

	return (
		<>
			{selectedIds.length > 0 && (
				<div className="design-count-section costing-tab bg-white collection-details-design-count">
					<div className="count-info d-flex justify-content-between align-items-center">
						<div className="design-count">
							<p className="regular-14">
								{selectedIds?.length}/{totalElements}
							</p>
						</div>
						<button
							className="button text size36"
							onClick={() => {
								if (selectAll) {
									setSelectAll(false);
									markAllToComplete(false);
								} else {
									setSelectAll(true);
									markAllToComplete(true);
								}
							}}
						>
							<span className="ml-1">
								{isAllSelected ? 'Unselect ' : 'Select'} {loadedItems} Items
							</span>
						</button>

						<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
							|
						</span>
						<button className="button text size36" onClick={() => onCompleteReview()}>
							<span>Complete Review</span>
						</button>
						<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
							|
						</span>
						<div
							className="text-right close-icon cursor-pointer"
							onClick={() => {
								setSelectedIds([]);
								setSelectAll(false);
							}}
						>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} />
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default InReviewBottomAction;
